// Deterministic family → hex colour mapping (consistent across all instances)
const PALETTE = [
  '#2dd4bf', '#f59e0b', '#818cf8', '#f43f5e',
  '#34d399', '#fb923c', '#a78bfa', '#60a5fa',
  '#e879f9', '#4ade80', '#fbbf24', '#f87171',
]

export function familyColour(family: string): string {
  let hash = 0
  for (let i = 0; i < family.length; i++) {
    hash = (hash * 31 + family.charCodeAt(i)) >>> 0
  }
  return PALETTE[hash % PALETTE.length]
}

export function familyColourHex(family: string): number {
  const hex = familyColour(family).replace('#', '')
  return parseInt(hex, 16)
}

export const STATE_COLOURS: Record<string, string> = {
  Busy:       '#2dd4bf',
  Processing: '#2dd4bf',  // same as Busy — simulation uses "Processing"
  Setup:      '#f59e0b',
  Failed:     '#f43f5e',
  Idle:       '#334155',
  OffShift:   '#1e2533',
  Off:        '#1e2533',
}
